import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetAdmin = async (id) => {
  /**
   * input: null
   * output: Admin object
   * description: fetches admin data
   */
  try {
    const ClientsCollection = await doc(
      db,
      "clients",
      getLocalStorageItem("bid")
    );
    const ClientsSnapshot = await getDoc(ClientsCollection);
    const ClientsData = ClientsSnapshot.data();

    const UserDocument = await doc(db, "users", ClientsData.uid);
    const UsersSnapshot = await getDoc(UserDocument);
    const UsersData = UsersSnapshot.data();
    return UsersData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAdmin;
